export default "/_next/static/chunks/react-transformed.65942f5820ad97d7da560e19e8b77c7c.glb";